<template>
  <w-icon-wrapper
    :height="23.75"
    :width="22"
    icon-name="work-product-storage-icon"
    view-box="0 0 22 23.75"
  >
    <g
      id="_74_Spezifischer_Lagerplatz"
      data-name="74 Spezifischer_Lagerplatz"
      transform="translate(27 -0.125)"
    >
      <rect
        id="Rechteck_4039"
        data-name="Rechteck 4039"
        width="6"
        height="6"
        transform="translate(-19 6)"
        fill="currentColor"
      />
      <path
        id="Pfad_55795"
        data-name="Pfad 55795"
        d="M-7,.125V18H-25V.125h-2v23.75h2V20H-7v3.875h2V.125Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55796"
        data-name="Pfad 55796"
        d="M-21.035,15.21h4.02V17h1.93V15.21h4.12V17h1.93V13.21h-13.93V17h1.93Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconProductStorage' };
</script>
